/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_Latest_Reply_ColInputs */

const en_admin_tickets_latest_reply_col = /** @type {(inputs: Admin_Tickets_Latest_Reply_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest Reply`)
};

/**
* | output |
* | --- |
* | "Latest Reply" |
*
* @param {Admin_Tickets_Latest_Reply_ColInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_tickets_latest_reply_col = /** @type {((inputs?: Admin_Tickets_Latest_Reply_ColInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_Latest_Reply_ColInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_tickets_latest_reply_col(inputs)
});
export { admin_tickets_latest_reply_col as "admin.tickets.latest_reply_col" }